import * as yup from 'yup';

export const createTsaScreenerSchema = yup.object().shape({
    name: yup.string().required(),
    unit: yup.string().required(),
    ccsfk9: yup.string().notRequired(),
    barcodeNumber: yup.string().required(),
    pin: yup.string().required(),
    active: yup.boolean().required(),
    createdBy: yup.string().required(),
    createdAt: yup.date().required(),
    modifiedBy: yup.string().required(),
    modifiedAt: yup.date().required()
});